import type { ReactElement } from "react";
import { useMemo } from "react";

import type { ChipItem } from "app/pages/sales-intelligence/common-components/filters-panel";
import type { IFilterViewBaseProps } from "app/pages/sales-intelligence/modules/advanced-search-filtering/types/filterInstance";
import { LimitedChipItems } from "app/pages/sales-intelligence/common-components/filters-panel";
import { FilterResultContainer } from "app/pages/sales-intelligence/common-components/filters-panel/components/styles";
import { MAX_CHIPS_GROUP_AMOUNT } from "app/pages/sales-intelligence/modules/leads-search-filters/constants";
import type FindExcludeByStaticListsFilter from "app/pages/sales-intelligence/modules/leads-search-filters/models/ExcludeByStaticListsFilter/ExcludeByStaticListsFilter";

const ExcludeByStaticListsFilterResult = ({
    filter: { options },
    value = [],
    isExpanded,
    isActionEnabled = true,
    onFilterUpdate,
    onFilterValueRemove,
}: IFilterViewBaseProps<FindExcludeByStaticListsFilter>): ReactElement | null => {
    const handleRemove = (id: string) => {
        const updatedValues = value?.filter((v) => v !== id);
        onFilterUpdate(updatedValues);
        onFilterValueRemove?.(updatedValues);
    };

    const chipItems: ChipItem[] = useMemo(() => {
        return value.map((item: string) => {
            const list = options.find((c) => c.opportunityListId == item);
            return {
                id: item,
                text: list?.friendlyName ?? item,
            };
        });
    }, [options, value]);

    if (!chipItems.length) {
        return null;
    }

    return (
        <FilterResultContainer>
            <LimitedChipItems
                items={chipItems}
                onDelete={handleRemove}
                maxItems={MAX_CHIPS_GROUP_AMOUNT}
                hideActionButton={!isActionEnabled}
                isTabExpanded={isExpanded}
            />
        </FilterResultContainer>
    );
};

export default ExcludeByStaticListsFilterResult;
